import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { CustomerSelectItem } from '../../../setup-equipment/setup-equipment.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EquipmentDetailsService } from '../../equipment-details.service';
import { GETSetupEquipmentService } from '../../../setup-equipment/setup-equipment.service';
import { UpdateSMUReadingModel, EquipmentSMUHistoryVM } from '../../equipment-details.model';
import { OrdinalDateAdapter, ORD_DATE_FORMATS } from '../../../adapters/ordinal-date-adapter';
import { NotificationsService } from 'angular2-notifications';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImplementDetailsService } from '../../../implement-details/implement-details.service';

@Component({
  selector: 'app-update-meter',
  templateUrl: './get-update-meter.component.html',
  styleUrls: ['./get-update-meter.component.scss'],
  providers: [
    {
      provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
  ]
})
export class GETUpdateMeterComponent implements OnInit {
  smuChangeTo: number;
  smuPrechange: number;
  dateOfReading: Date = new Date();
  saving: boolean = false;
  private _equipmentId: number;
  private _subscriptions: Subscription[] = [];
  customerList: CustomerSelectItem[] = [];
  selectedCustomer: number;

  lastUpdateTime: Date;

  smuForm: FormGroup;
  smuReadingInput: FormControl;

  bcmChangeTo: number;
  bcmPrechange: number;
  bcmReadingInput: FormControl;

  tonChangeTo: number;
  tonPrechange: number;
  tonReadingInput: FormControl;

  SMUHistory: EquipmentSMUHistoryVM[];
  // smuReadingInput = new FormControl('', [Validators.required]);
  ttDate: string = "Click here to select a date.";
  maxDate = new Date();


  ///new chnages
  selectSMU: Boolean = true;

  startDate: Date = new Date();
  endDate: Date = new Date();
  actionType: number = 1;

  implementId:number;
  smuReadingInputValidation() {
    return this.smuChangeTo < this.smuPrechange;
  }
  inputSMUErrorMessage() {
    return this.smuReadingInput.hasError('required') ? 'You must enter a value' :
      ''
      ;
  }

  bcmReadingInputValidation() {
    return this.bcmChangeTo < this.bcmPrechange;
  }
  inputBCMErrorMessage() {
    return this.bcmReadingInput.hasError('required') ? 'You must enter a value' :
      ''
      ;
  }

  tonReadingInputValidation() {
    return this.tonChangeTo < this.tonPrechange;
  }
  inputTONErrorMessage() {
    return this.tonReadingInput.hasError('required') ? 'You must enter a value' :
      ''
      ;
  }


  constructor(
    public dialogRef: MatDialogRef<GETUpdateMeterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _equipment: EquipmentDetailsService, private _setupEquipmentService: GETSetupEquipmentService,
    public toastr: NotificationsService, vRef: ViewContainerRef, private _moduleService: ImplementDetailsService
  ) {

  }

  ngOnInit() {

    this._setupEquipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
      this.selectedCustomer = this.data.customerId;
      this.lastUpdateTime = this.data.lastUpdateTime;
    });
    this._equipmentId = this.data.equipmentId;
    this.smuPrechange = this.data.smuPrechange;
    this.implementId = this.data.implementId;
    //this.bcmPrechange =this.data.bcmPrechange;
    //this.tonPrechange =this.data.tonPrechange;


    //this.bcmChangeTo =this.bcmPrechange;
    //this.tonChangeTo=this.tonPrechange;



    this.createFormControls(this.smuPrechange, this.bcmPrechange, this.tonPrechange);
    this.createForm();
    this.loadHistoryTable();
  }

  changeLateUpdateTime(lastUpdateTime: any) {
    if (lastUpdateTime != undefined && lastUpdateTime instanceof Date) {
      this.lastUpdateTime = lastUpdateTime;
    }

  }
  validate: boolean = false;
  Checkvalidations() {
    console.log(this.bcmChangeTo, this.tonChangeTo)
    if ((this.bcmChangeTo !== undefined && this.bcmChangeTo > this.bcmPrechange) || this.bcmChangeTo == undefined) {
      this.validate = true;

    }
    if ((this.tonChangeTo !== undefined && this.tonChangeTo > this.tonPrechange) || this.tonChangeTo == undefined) {
      this.validate = true;

    }
  }
    
  loadHistoryTable() {
    this._subscriptions.push(this._equipment.GetSMUReadingHistory(this._equipmentId, this.implementId).subscribe((result: any) => {
      console.log("History", result)
      this.SMUHistory = result
    
    }));
  }

 createFormControls(preChangeSMU: number, preChangeBCM: number, preChangeTON: number) {
    this.smuReadingInput = new FormControl('', [
      Validators.required,
      Validators.min(preChangeSMU),
    ]);

    this.bcmReadingInput = new FormControl('', [
      Validators.required,
      Validators.min(preChangeBCM),
    ]);

    this.tonReadingInput = new FormControl('', [
      Validators.required,
      Validators.min(preChangeTON),
    ]);

    this.Checkvalidations();
  }
  createForm() {
    this.smuForm = new FormGroup({
      smuReadingInput: this.smuReadingInput,
      bcmReadingInput: this.bcmReadingInput,
      tonReadingInput: this.smuReadingInput,
    });

  }

  updateMeterClicked(): void {

    if(this.implementId==null) this.implementId = 0;


    let updateModel = new UpdateSMUReadingModel();
    updateModel.currentReading = this.smuChangeTo;
    updateModel.dateReadSMU = this.dateOfReading;
    updateModel.equipmentId = this._equipmentId;
    updateModel.startDate = this.startDate;
    updateModel.endDate = this.endDate;

    if (this.tonChangeTo == undefined)
      updateModel.ton = -1;
    else
      updateModel.ton = this.tonChangeTo;

    if (this.bcmChangeTo == undefined)
      updateModel.bcm = -1;
    else
      updateModel.bcm = this.bcmChangeTo;


    if (this.smuChangeTo == 0)
      return;
    this.saving = true;
    if (this.actionType == 1) {
      this._subscriptions.push(this._equipment.changeSMUReading(updateModel).subscribe(succeeded => {
        this.saving = false;
        if (succeeded.m_Item1) {
          this.toastr.success('Meter Reading updated', 'This equipment meter reading has been successfully changed to ' + updateModel.currentReading + '.');
          this.dialogRef.close(succeeded.m_Item1);
        } else {
          this.toastr.error(succeeded.m_Item2);
        }
      }));
      if (this.implementId > 0) {
        this._subscriptions.push(this._moduleService.checkAndRecalculateImplementAndComponentsLife(this.implementId, this.dateOfReading).subscribe(res => {
        }));
      }
    }
    else {
      this._subscriptions.push(this._equipment.changeEquipmentBCMTonsReading(updateModel,this.implementId).subscribe(succeeded => {
        this.saving = false;
        if (succeeded.m_Item1) {
          this.toastr.success('BCM/Tons Reading updated.');
          this.dialogRef.close(succeeded.m_Item1);
        } else {
          this.toastr.error(succeeded.m_Item2);
        }
      }));
    }

  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => {
      if (!s.closed)
        s.unsubscribe();
    });
  }


  onNoClick(): void {
    this.dialogRef.close(false);
  }

  doSmu() {
    this.selectSMU = true;
  }
  doBcmTon() {
    this.selectSMU = false;
  }

  getDate(value): string {
    var input = value;
    var fields = input.split(' ');
    var date = ''
    if(fields[2].length <= 1){
       date = `0${fields[2]}`
       var date_ = fields[0] + " " + date + " " + fields[3] + " "
       return date_
    }else{
      var date_ = fields[0] + " " + fields[1] + " " + fields[2] + " "
      return date_;
    }

   

  }

  onNumberInput(event: Event, property: 'smuChangeTo' | 'bcmChangeTo' | 'tonChangeTo'): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, '');

    this[property] = input.value ? Number(input.value) : 0;
  }




}
